import type { RoomExtra } from '@features/rooms';
import type { ConfigurationGroupOptionType } from 'shared-types/SpaPackage';
import { OvernightPackageRoomExtra, OvernightPackageSpaExtras } from '../types';

export const toRoomExtraEntries = (extras: RoomExtra[]): OvernightPackageRoomExtra[] =>
  extras.map((extra) => ({ ...extra, isSelected: false, quantity: 1 }));

export const toSpaExtraEntries = (
  adaptedExtras: ConfigurationGroupOptionType[]
): NonNullable<OvernightPackageSpaExtras> =>
  adaptedExtras.map((extra) => ({
    extra: extra.extra ?? { id: extra.id },
    priceAmount: extra.price?.amount ?? 0,
    selectedGuestDetails: [],
  }));

export const fillMissingEntries = <T>(seeded: T[], current: (T | undefined)[]): T[] =>
  seeded.map((entry, index) => current[index] ?? entry);
